import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';
import { FilterOptions } from '../../hooks/useFilters';

const USER_ENDPOINT = '/users';

export class UserService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE USUARIOS
     * @EN GETS THE LIST OF USERS
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listUsers = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN USUARIO POR SU ID
     * @EN GETS A USER BY ITS ID
     * 
     * @param userId
     */
    // -------------------------------------------------------------------------------------------------------------
    getUserById = async (userId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/get',
            data: { id: userId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UN USUARIO
     * @EN TOGGLES A USER
     * 
     * @param userId
     * @param status
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleUserStatus = async (userId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/toggle',
            data: { id : userId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES AÑADE UN DOCUMENTO A UN USUARIO
     * @EN ADDS A DOCUMENT TO A USER
     * 
     * @param data
     */
    // -------------------------------------------------------------------------------------------------------------
    addUserDocument = async (data: FormData) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/add-document',
            data: data,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN USUARIO
     * @EN CREATES A USER
     * 
     * @param user
     */
    // -------------------------------------------------------------------------------------------------------------
    createUser = async (user: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/create',
            data: user,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN USUARIO
     * @EN EDITS A USER
     * 
     * @param user
     */
    // -------------------------------------------------------------------------------------------------------------
    editUser = async (user: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/edit',
            data: user,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA LA IMAGEN DE UN USUARIO
     * @EN EDITS THE IMAGE OF A USER
     * 
     * @param id
     * @param img
     */
    // -------------------------------------------------------------------------------------------------------------
    editUserImg = async (id: string, img: File) => {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('profileImg', img);

        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/add-image',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA LA IMAGEN DE UN USUARIO
     * @EN DELETES THE IMAGE OF A USER
     * 
     * @param userId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteUserImg = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/delete-image',
            data: { id }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN USUARIO
     * @EN DELETES A USER
     * 
     * @param userId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteUser = async (userId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/delete',
            data: { id: userId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS USUARIOS
     * @EN DELETES MULTIPLE USERS
     * 
     * @param userIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiUsers = async (userIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/delete-multi',
            data: { userIds }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA LOS PERMISOS DE UN USUARIO
     * @EN EDITS THE PERMISSIONS OF A USER
     * 
     * @param user
     * @param company
     * @param permissions
     */
    //-------------------------------------------------------------------------------------------------------------
    editUserPermissions = async (user: string, company: string | null, permissions: number[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/edit-permissions',
            data: {
                id: user,
                company: company,
                permissions: permissions
            }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA LA CONTRASEÑA DE UN USUARIO
     * @EN CHANGES THE PASSWORD OF A USER
     * 
     * @param userId
     * @param password
     * @param passwordConfirm
     */
    //-------------------------------------------------------------------------------------------------------------
    changePassword = async (userId: string, password: string, passwordConfirm: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/change-password',
            data: { id: userId, password, passwordConfirm }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------
   
    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE DOCUMENTOS DE UN USUARIO
     * @EN GETS THE LIST OF DOCUMENTS OF A USER
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listUserDocuments = async (filters: FilterOptions) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/list-documents',
            data: filters,
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN DOCUMENTO DE UN USUARIO
     * @EN GETS A DOCUMENT OF A USER
     * 
     * @param userId
     * @param maxResults
     */
    //-------------------------------------------------------------------------------------------------------------
    getUserDocuments = async (userId: string, maxResults?: number | string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/get-documents',
            data: { userId, maxResults },
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------
   
    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE ROLES DE UN USUARIO
     * @EN GETS THE LIST OF ROLES OF A USER
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listRolesByUser = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/list-user-roles',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA CONFIGURACIÓN DE LA EMPRESA
     * @EN GETS THE COMPANY CONFIGURATION
     */
    //-------------------------------------------------------------------------------------------------------------
    getCompanyConfiguration = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: USER_ENDPOINT + '/get-company-configuration',
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------



    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE USUARIOS
     * @EN GETS THE LIST OF USERS
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES RESETEA LOS PERMISOS DE UN USUARIO
     * @EN RESETS THE PERMISSIONS OF A USER
     * 
     * @param userId
     */
    // -------------------------------------------------------------------------------------------------------------
    resetPermissions = async (userId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/reset-permissions',
            data: { id: userId },
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES INICIA SESIÓN COMO USUARIO
     * @EN LOGINS AS A USER
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    loginAsUser = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: USER_ENDPOINT + '/login-as-user',
            data: { id }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}